/* Galeria nativa da Luveon.
   As paginas de produto foram exportadas do GemPages como HTML estatico: o trilho,
   as setas e as miniaturas existem no markup, mas o motor do app nao carrega na loja.
   Este arquivo liga o que ja esta la — nao redesenha nada.

   Dois mapas por produto, ambos com o indice ORIGINAL da foto no trilho:
   OCULTAR — fotos que saem da galeria (cor que a loja parou de vender). Ficam no
     HTML, apenas escondidas: mexer no export minificado quebraria o trilho, que em
     algumas paginas ja vem com div sem fechamento.
   CORES   — a foto que abre quando a cliente escolhe a cor no bloco de oferta.
     Produto sem entrada aqui so ganha navegacao. */
(function () {
  "use strict";

  var OCULTAR = {
    "legging-shorty-luveon": [5, 11]
  };

  var CORES = {
    "short-poche-luveon":         { "Noir": 0, "Gris": 1, "Bleu Marine": 2 },
    "debardeur-luveon":           { "Noir": 0, "Gris": 4, "Bleu Marine": 5, "Vert Paon": 3 },
    "legging-shorty-luveon":      { "Noir": 0, "Gris": 6, "Bleu Marine": 7 },
    "leggings-luveon-avec-poche": { "Noir": 0, "Bleu Marine": 6, "Gris": 7 },
    "leggings-3d-luveon":         { "Noir": 7, "Gris": 8, "Vert Paon": 9, "Beige": 10, "Bleu Marine": 11,
                                    "Rose": 12, "Bleu": 13, "Jaune": 14, "Violet clair": 15 },
    "tee-shirt-3d":               { "Noir": 7, "Rose": 8 },
    "leggings-short-3d":          { "Noir": 0, "Gris": 5 },
    "brassiere-luveon":           { "Noir": 0, "Bleu Marine": 3, "Gris": 4, "Vert Paon": 5 }
  };

  function handleDoProduto() {
    var b = document.querySelector("[data-luv-bundle][data-produto]");
    if (b) return b.getAttribute("data-produto");
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : "";
  }

  function trilho(raiz, tipo) {
    return raiz.querySelector('[class*="gp-carousel-slider-gp-' + tipo + '-"]');
  }

  function liga(raiz, handle) {
    var carrossel = trilho(raiz, "carousel");
    if (!carrossel) return null;
    var todasFotos = Array.prototype.slice.call(carrossel.children);
    if (todasFotos.length < 2) return null;

    var miniaturas = trilho(raiz, "gallery");
    var todasMinis = miniaturas ? Array.prototype.slice.call(miniaturas.children) : [];

    /* Esconde as fotos aposentadas e guarda so as que continuam na galeria. */
    var fora = OCULTAR[handle] || [];
    var ordem = [];
    todasFotos.forEach(function (el, i) {
      if (fora.indexOf(i) >= 0) {
        el.style.display = "none";
        if (todasMinis[i]) todasMinis[i].style.display = "none";
      } else {
        ordem.push(i);
      }
    });
    var fotos = ordem.map(function (i) { return todasFotos[i]; });
    var minis = ordem.map(function (i) { return todasMinis[i]; }).filter(Boolean);

    var setas = Array.prototype.slice.call(
      raiz.querySelectorAll('[class*="gp-carousel-arrow-gp-carousel-"]')
    );

    var atual = 0;
    carrossel.classList.add("luv-trilho");
    if (miniaturas) miniaturas.classList.add("luv-miniaturas");

    /* O trilho e quem corta as fotos (overflow hidden). Mover o proprio trilho
       levaria a janela de corte junto e a area ficaria em branco: quem anda e a
       rolagem interna dele. */
    function mostra(i, suave) {
      atual = (i % fotos.length + fotos.length) % fotos.length;
      var desloc = fotos[atual].offsetLeft - fotos[0].offsetLeft;
      carrossel.scrollTo({ left: desloc, behavior: suave === false ? "auto" : "smooth" });
      minis.forEach(function (m, n) { m.classList.toggle("luv-mini-ativa", n === atual); });
      var m = minis[atual];
      if (m && miniaturas) {
        var alvo = m.offsetLeft - (miniaturas.clientWidth - m.offsetWidth) / 2;
        miniaturas.scrollTo({ left: Math.max(0, alvo), behavior: "smooth" });
      }
    }

    minis.forEach(function (m, n) {
      m.style.cursor = "pointer";
      m.addEventListener("click", function () { mostra(n); });
    });

    if (setas[0]) setas[0].addEventListener("click", function (e) { e.preventDefault(); mostra(atual - 1); });
    if (setas[1]) setas[1].addEventListener("click", function (e) { e.preventDefault(); mostra(atual + 1); });

    // arrasto no celular
    var x0 = null, y0 = null, arrastando = false;
    carrossel.addEventListener("pointerdown", function (e) {
      x0 = e.clientX; y0 = e.clientY; arrastando = true;
    });
    carrossel.addEventListener("pointermove", function (e) {
      if (!arrastando) return;
      if (Math.abs(e.clientY - y0) > Math.abs(e.clientX - x0)) { arrastando = false; }
    });
    ["pointerup", "pointercancel", "pointerleave"].forEach(function (ev) {
      carrossel.addEventListener(ev, function (e) {
        if (!arrastando) return;
        arrastando = false;
        var d = e.clientX - x0;
        if (Math.abs(d) > 40) mostra(atual + (d < 0 ? 1 : -1));
      });
    });

    window.addEventListener("resize", function () { mostra(atual, false); });
    mostra(0, false);

    /* Traduz o indice original (o que esta em CORES) para a posicao atual na galeria. */
    mostra.porIndiceOriginal = function (i) {
      var pos = ordem.indexOf(i);
      if (pos >= 0) mostra(pos);
    };
    return mostra;
  }

  function ligaCor(mostra, handle) {
    var mapa = CORES[handle];
    if (!mapa || !mostra) return;
    document.addEventListener("change", function (e) {
      var s = e.target;
      if (!s || s.tagName !== "SELECT" || !s.hasAttribute("data-luv-opcao")) return;
      if ((s.getAttribute("aria-label") || "").toLowerCase().indexOf("couleur") === -1) return;
      var i = mapa[s.value];
      if (typeof i === "number") mostra.porIndiceOriginal(i);
    });
  }

  function inicia() {
    var handle = handleDoProduto();
    var raizes = Array.prototype.slice.call(document.querySelectorAll("gp-product-images"));
    var principal = null;
    raizes.forEach(function (r) {
      var m = liga(r, handle);
      if (m && !principal) principal = m;
    });
    ligaCor(principal, handle);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", inicia);
  } else {
    inicia();
  }
})();
